import { Avatar, idToColor } from "@themis/ui";
import React from "react";

import { useContact } from "@/api/queries/contacts";
import Spinner from "@/components/table/shared/Spinner";

export function AccountContactCell({
  mainContactId,
  display,
}: {
  mainContactId: number;
  display: "name" | "email";
}) {
  const { data, isLoading } = useContact(mainContactId);

  if (isLoading) {
    return <Spinner />;
  }

  if (!data?.contact) {
    return null;
  }

  return (
    <div className="tw-flex tw-items-center tw-gap-1.5 tw-overflow-hidden">
      {display === "name" && (
        <Avatar size="lg" color={idToColor(mainContactId)}>
          {data.contact.initials}
        </Avatar>
      )}
      <p className="tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap tw-font-semibold">
        {display === "name" ? data.contact.full_name : data.contact.email}
      </p>
    </div>
  );
}
